export { default } from 'ui/components/ui/classic/settings-panel/sp-body/sp-content';
